console.debug("AwayFL - AwayFL-Player - 0.2.4");
export { Player } from "./lib/Player";
export { PlayerAVM1 } from "./lib/PlayerAVM1";
